module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-literacy-for-all.json
// module id = 409
// module chunks = 50132571673065